import styled from "styled-components";

export const StyledEmptyMarketGif = styled.img`
    width: 80%;
    object-fit: contain;
`;
